export const PATIENT_HEALTH_EVALUATION = {
  good: "Gott",
  average: "Medel",
  bad: "Dåligt",
};
